<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item
              ><a @click.prevent="goBack">国家配置管理</a></el-breadcrumb-item
            >
            <el-breadcrumb-item>国家配置详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-form
          ref="myConfigForm"
          :model="configFormData"
          :rules="configFormRules"
          :label-width="formLabelWidth"
        >
          <el-form-item label="国家名称:" prop="area_id">
            <el-select
              v-model="configFormData.area_id"
              filterable
              clearable
              @change="areaSelectChange"
            >
              <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.area_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <!-- <el-button style="margin-left: 10px" v-if="change_id" @click="areaSelectChange(3290,true)">载入默认配置</el-button> -->
          </el-form-item>
          <div class="zv-flex-wrap">
            <div class="zv-form-item-label">参考因素配置:</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <el-table
                :data="riskTypeCustomData"
                style="width: 100%"
                class="my-expand-table"
              >
                <el-table-column type="expand" :width="120" :align="tableAlign">
                  <template slot="header" slot-scope="scope">
                    <span>模块内容配置</span>
                  </template>
                  <template slot-scope="scope">
                    <el-table
                      :data="riskTypeCustomData[scope.$index].risk_field"
                      style="width: 100%"
                      class="my-expand-table"
                    >
                      <el-table-column
                        label="名称"
                        :align="tableAlign"
                        prop="field_name"
                      >
                      </el-table-column>
                      <el-table-column label="条件类型" :align="tableAlign">
                        <template slot-scope="scope">
                          <span>{{
                            scope.row.field_type == 1 ? "单条件" : "多条件"
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="因素配置" :align="tableAlign">
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            @click="openPeopleNumFieldDialog(scope.row)"
                            v-if="
                              scope.row.field_name == '涉事人数' ||
                                scope.row.field_name == '华人涉事人数'
                            "
                            >新增</el-button
                          >
                          <el-button
                            type="text"
                            @click="openCommonFieldDialog(scope.row)"
                            v-else
                            >新增</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column
                  label="风险类型"
                  :align="tableAlign"
                  prop="risk_name"
                >
                </el-table-column>
                <el-table-column
                  label="分类"
                  :align="tableAlign"
                  prop="target_name"
                >
                </el-table-column>
                <el-table-column label="模块初始值" :align="tableAlign">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      v-model.number="
                        riskTypeCustomData[scope.$index].defaultValue
                      "
                      placeholder="0~100整数"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="涉华判断预设值" :align="tableAlign">
                  <template
                    slot-scope="scope"
                    v-if="scope.row.target_type == 1"
                  >
                    <el-input
                      type="number"
                      v-model.number="
                        riskTypeCustomData[scope.$index].sheHuaValue
                      "
                      placeholder="0~100整数"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="zv-flex-wrap" style="padding-top: 20px;">
            <div class="zv-form-item-label">重大时间节点:</div>
            <div
              class="zv-form-item-content"
              style="display: block; max-width: 1205px;"
            >
              <div style="padding-bottom: 10px;">
                <el-button type="primary" size="mini" @click="doAdd"
                  >添加重大时间节点</el-button
                >
              </div>
              <zv-table :table="table" ref="dataTable"> </zv-table>
            </div>
          </div>
          <el-form-item label-width="auto" class="fi-flex-center paddint-t-30">
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="doConfigFormSubmit"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <zv-dialog
        width="450px"
        :title="isEdit ? '修改重大时间节点' : '新增重大时间节点'"
        :showDialog.sync="showFormDialog"
      >
        <div slot="content">
          <el-form
            ref="myForm"
            label-width="140px"
            :model="formData"
            :rules="formRules"
            status-icon
          >
            <el-form-item label="重大时间节点名称:" prop="festival">
              <el-input
                v-model="formData.festival"
                clearable
                style="width: 220px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="起始时间:" prop="begin_time">
              <el-date-picker
                class="el-input-width1"
                v-model="formData.begin_time"
                type="datetime"
                placeholder="选择起始时间"
                :picker-options="pickerOptions"
                value-format="timestamp"
                style="width: 220px;"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="终止时间:" prop="end_time">
              <el-date-picker
                class="el-input-width1"
                v-model="formData.end_time"
                type="datetime"
                placeholder="选择终止时间"
                :picker-options="pickerOptions"
                value-format="timestamp"
                :default-time="'23:59:59'"
                style="width: 220px;"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="是否每年重复：">
              <el-switch
                v-model="formData.year_repeat"
                :inactive-value="0"
                :active-value="1"
              ></el-switch>
            </el-form-item>

            <el-form-item label="风险区域:">
              <el-input
                v-model="formData.risk_area"
                clearable
                type="textarea"
                autosize
              ></el-input>
            </el-form-item>
            <el-form-item label="高发风险:">
              <el-input
                type="textarea"
                autosize
                v-model="formData.high_risk_type"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item label="开启风险前瞻：">
              <el-switch
                v-model="formData.risk_prospect"
                :inactive-value="0"
                :active-value="1"
              ></el-switch>
            </el-form-item>

            <el-form-item label="是否开启：" prop="is_open" v-if="isEdit">
              <el-switch
                v-model="formData.is_open"
                :inactive-value="0"
                :active-value="1"
              ></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div slot="btns">
          <el-button @click="showFormDialog = false">取消</el-button>
          <el-button type="primary" @click="isEdit ? submitEditForm():submitForm()">确定</el-button>
        </div>
      </zv-dialog>

      <zv-dialog
        width="500px"
        :title="commonFieldDialogTitle"
        :showDialog.sync="showCommonFieldDialog"
      >
        <div slot="content">
          <div style="text-align: right; padding-bottom: 10px;">
            <el-button type="primary" @click="doAddCommonFieldRow()"
              >添加选项</el-button
            >
            <el-button type="primary" @click="batchOperate = false"
              >批量添加</el-button
            >
          </div>
          <el-table
            v-if="batchOperate"
            :data="commonFieldTableData"
            class="style-auto-height"
            style="margin-bottom: 10px;"
          >
            <el-table-column :align="tableAlign" label="选项名称">
              <template slot-scope="scope">
                <el-input
                  type="text"
                  v-model.trim="scope.row.risk_field_value"
                  placeholder="选项名称"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :align="tableAlign" label="选项得分">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model.number="scope.row.risk_field_score"
                  placeholder="0~100整数"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :align="tableAlign" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="deleteCommonFieldItem(scope)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-input
            v-else
            type="textarea"
            :rows="6"
            placeholder="批量添加"
            v-model="batchVal">
          </el-input>
          <div v-if="!batchOperate" style="text-align: right; padding-top: 10px;">
            <el-button type="primary" @click="doAddCommonFieldRow2()"
              >添加</el-button
            >
          </div>
        </div>
        <div slot="btns">
          <el-button @click="showCommonFieldDialog = false">取消</el-button>
          <el-button type="primary" @click="saveCommonFieldData"
            >确定</el-button
          >
        </div>
      </zv-dialog>

      <zv-dialog
        width="1000px"
        :title="peopleNumFieldDialogTitle"
        :showDialog.sync="showPeopleNumFieldDialog"
      >
        <div slot="content">
          <div style="text-align: right; padding-bottom: 10px;">
            <el-button type="primary" @click="doAddPeopleNumFieldRow()"
              >添加选项</el-button
            >
          </div>
          <el-table
            :data="peopleNumFieldTableData.data"
            class="style-auto-height"
            style="margin-bottom: 10px;"
          >
            <el-table-column :align="tableAlign" label="涉案类型">
              <template slot-scope="scope">
                <el-select v-model="scope.row.invovledKey" filterable clearable>
                  <el-option
                    v-for="item in $enums.InvolvedType.list"
                    :key="item.key"
                    :label="item.text"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              :align="tableAlign"
              v-for="(column, index) in peopleNumFieldTableData.columnScores"
              :key="index"
            >
              <template slot="header" slot-scope="scope">
                <el-input
                  type="number"
                  v-model.number="column.score"
                  placeholder="0~100分数"
                ></el-input>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row['value' + (index + 1)]"
                  placeholder="[0,10]"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :align="tableAlign" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="deletePeopleNumFieldItem(scope)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="btns">
          <el-button @click="showPeopleNumFieldDialog = false">取消</el-button>
          <el-button type="primary" @click="savePeopleNumFieldData"
            >确定</el-button
          >
        </div>
      </zv-dialog>
    </div>
  </div>
</template>

<script>
import api from "./api";
import formPageMixin from "@/mixins/formPageMixin";
import addFormMixin from "@/mixins/addFormMixin";
import TipUtil from "@/utils/utils/TipUtil";
import _ from "lodash";

export default {
  name: "CreateAreaRiskConfig",
  mixins: [formPageMixin, addFormMixin],
  components: {},
  data() {
    let vm = this;
    return {
      change_id: false, // 2020.6.9 新增change_id
      changeTurn: '', // 2020.6.9 传入area_id判断(修改后，可删除)
      idTurn: vm.$route.query.area_id, // 2020.6.9 新增载入默认配置按钮
      area_id: "", // 地区id
      isConfigEdit: false, // 是否为编辑
      areaData: [], // 地区数据,
      riskTypeData: [], // 风险类别数据
      riskTypeCustomData: [], // 风险类别自定义数据
      areaRiskConfigInfo: {}, // 模型主体详情
      areaRiskConfigItems: [], // 模型主体
      configFormData: {
        area_id: "" // 主体（国家）id
      },

      configFormRules: {
        area_id: {
          required: true,
          message: "主体不能为空",
          trigger: "change"
        }
      },

      table: {
        api: api.festivalList,
        query: {
          page: 1,
          pagesize: 99999
        },
        searchData: [],
        autoHeight: true,
        autoLoading: false,
        hidePagination: true,
        columns: [
          {
            title: "重大时间节点名称",
            key: "festival",
            minWidth: "150",
            showTooltip: true
          },
          {
            title: "起始时间",
            key: "begin_time",
            minWidth: "150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", ctx.row.begin_time.toString().length > 10 ? vm.$commFunc.formatDate(ctx.row.begin_time/1000):vm.$commFunc.formatDate(ctx.row.begin_time));
            }
          },
          {
            title: "终止时间",
            key: "end_time",
            minWidth: "150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", ctx.row.end_time.toString().length > 10 ? vm.$commFunc.formatDate(ctx.row.end_time/1000):vm.$commFunc.formatDate(ctx.row.end_time));
            }
          },
          {
            title: "开启状态",
            key: "is_open",
            minWidth: "150",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.is_open,
                  "inactive-value": 0,
                  "active-value": 1
                  // "inactive-text": "关闭",
                  // "active-text": "开启"
                },
                on: {
                  change(status) {
                    vm.doChangeFestivalStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth: "150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];
              arr.push(editBtn);

              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },

      formDataOri: {
        id: "",
        area_id: "",
        festival: "",
        begin_time: "",
        end_time: "",
        risk_area: "", //1.4新增 2020.7.28 风险区域
        high_risk_type: "", //1.4新增 2020.7.28 高发风险
        risk_prospect: "", //1.4新增 2020.7.28 风险前瞻
        is_open: 1
      },

      formRules: {
        festival: {
          required: true,
          message: "重大时间节点名称不能为空",
          trigger: "blur"
        },
        begin_time: {
          required: true,
          message: "起始时间不能为空",
          trigger: "blur"
        },
        end_time: {
          required: true,
          message: "终止时间不能为空",
          trigger: "blur"
        }
      },

      adddApi: api.addFestival,
      editApi: api.editFestival,
      deleteApi: api.deleteFestival,
      addSuccessMsg: "添加重大时间节点成功",
      editSuccessMsg: "编辑重大时间节点成功",
      deleteSuccessMsg: "删除重大时间节点成功",

      showCommonFieldDialog: false,
      commonFieldTableDataOri: {
        // 原始数据
        title: "",
        risk_id: "",
        risk_field_id: "",
        data: []
      },
      commonFieldTableData: [], // 与新增表单绑定的数据

      showPeopleNumFieldDialog: false,
      peopleNumFieldTableDataOri: {
        target_type: 1,
        id: "",
        title: "",
        risk_id: "",
        risk_field_id: "",
        data: [],
        columnScores: []
      },
      peopleNumFieldTableData: {},
      batchOperate: false,
      batchVal: ''
    };
  },
  computed: {
    commonFieldDialogTitle() {
      let typeStr =
        this.commonFieldTableDataOri.target_type == 1 ? "通用" : "华人";
      return `【${this.commonFieldTableDataOri.title}•${typeStr}】模块内容配置`;
    },

    peopleNumFieldDialogTitle() {
      let typeStr =
        this.peopleNumFieldTableData.target_type == 1 ? "通用" : "华人";
      return `【${this.peopleNumFieldTableData.title}•${typeStr}】模块内容配置`;
    }
  },

  methods: {
    initCommonData() {
      this.configFormData.area_id = this.area_id;
      this.$commFunc.getAreaList({ area_type: 2 }).then(res => {
        this.areaData = res;
      });

      this.getAreaCommonData();
    },

    areaSelectChange(area_id,turn) {
      if(!turn) {
        this.change_id = area_id
      }
      console.log(this.change_id)
      this.changeTurn = turn
      this.area_id = area_id;
      this.getAreaCommonData();
    },

    async getAreaCommonData() {
      this.getFestivalList();
      await this.getAreaRiskConfigInfo();
      this.getRiskTypeData();
    },

    getRiskTypeData() {
      this.$commFunc.getRiskTypeList().then(resData => {
        this.riskTypeData = resData;
        this.processRiskTypeData(resData);
      });
    },

    processRiskTypeData(resData) {
      let myRiskArr = [];
      resData.forEach(item => {
        let countArr = [1, 2];
        countArr.forEach(cItem => {
          let tempObj = this.$_.pick(item, [
            "id",
            "risk_name",
            "full_risk_name"
          ]);
          tempObj.target_type = cItem;
          tempObj.target_name = cItem == 1 ? "通用" : "华人";
          let findIndex = this.areaRiskConfigInfo.findIndex(
            fItem => fItem.target_type == cItem && fItem.risk_id == item.id
          );
          tempObj.defaultValue =
            findIndex > -1
              ? this.areaRiskConfigInfo[findIndex].default_score
              : "";
          tempObj.sheHuaValue =
            findIndex > -1
              ? this.areaRiskConfigInfo[findIndex].chinese_threshold_score
              : "";
          tempObj.risk_field = item.risk_field.filter(
            fItem => fItem.target_type == cItem
          );
          tempObj.risk_field.forEach(feItem => {
            feItem.risk_id = item.id;
          });
          myRiskArr.push(tempObj);
        });
      });

      this.riskTypeCustomData = myRiskArr;
    },

    // 获取模块详情
    async getAreaRiskConfigInfo() {
      if (this.area_id) {
        // 获取模型主体详情信息
        let res = await api.areaRiskConfigDetail({
          area_id: this.area_id
        });

        this.areaRiskConfigInfo = res.info;
      }
    },

    // 获取节日列表
    async getFestivalList() {
      this.table.query.area_id = this.area_id;
      let res = await api.festivalList({
        page: 1,
        pagesize: 99999,
        area_id: this.area_id
      });

      console.log(res);

      this.$refs.dataTable.setTableData(res.list);
    },

    beforeSubmit() {
      this.submitData.area_id = this.area_id;
      if(this.formData.begin_time.toString().length > 10) {
        this.$set(this.submitData,"begin_time",this.formData.begin_time/1000)
        this.$set(this.submitData,"end_time",this.formData.end_time/1000)
      }
      // this.submitData.begin_time = this.$commFunc.parseToTimestamp(
      //   this.submitData.begin_time_str
      // );
      // this.submitData.end_time = this.$commFunc.parseToTimestamp(
      //   this.submitData.end_time_str
      // );
    },

    async doChangeFestivalStatus(status, id) {
      await this.editApi({
        id,
        is_open: status
      });
      this.$refs.dataTable.refresh();
      this.$message("状态修改成功!");
    },

    dealEditItem(editItem) {
      let processObj = this.$_.cloneDeep(editItem);
      processObj.begin_time_str = this.$commFunc.formatDate(
        processObj.begin_time
      );
      processObj.end_time_str = this.$commFunc.formatDate(processObj.end_time);
      return processObj;
    },

    doAdd() {
      if (!this.area_id) {
        TipUtil.message("请先选择国家", "error");
        return false;
      }
      this.formData = this.$_.cloneDeep(this.formDataOri);
      this.isEdit = false;
      this.showFormDialog = true;
    },

    doConfigFormSubmit() {
      this.$refs.myConfigForm.validate(async valid => {
        if (!valid) {
          TipUtil.message("请检查表单!", "warning");
          return;
        }
        let processObj = this.processSubmitData();
        console.log(processObj);
        let res = await api.addAreaRiskConfig(processObj);
        console.log(res);
        let msg = this.isConfigEdit ? "修改国家配置成功" : "新增国家配置成功";
        TipUtil.message(msg, "success");
        setTimeout(() => {
          this.goBack();
        }, 200);
      });
    },

    processSubmitData() {
      let processObj = {
        area_id: this.change_id == false ? this.area_id:this.change_id,
        risk_id: this.riskTypeData.map(item => item.id).join(","),
        risk_field_default_score: this.getSubmitRiskDefaultScore(),
        chinese_threshold_score: this.getSubmitRiskSheHuaScore()
      };

      return processObj;
    },

    getSubmitRiskDefaultScore() {
      let retArr = [];
      this.riskTypeData.forEach(item => {
        let filterArr = this.riskTypeCustomData.filter(
          fItem => fItem.id == item.id
        );
        let mapArr = filterArr.map(mItem => mItem.defaultValue);
        retArr.push(mapArr.join("#"));
      });

      return retArr.join(",");
    },

    getSubmitRiskSheHuaScore() {
      let filterArr = this.riskTypeCustomData.filter(
        fItem => fItem.target_type == 1
      );
      let retArr = filterArr.map(mItem => mItem.sheHuaValue);
      return retArr.join(",");
    },

    async openCommonFieldDialog(scopeRow) {
      this.$set(this.commonFieldTableDataOri, "risk_id", scopeRow.risk_id);
      this.$set(this.commonFieldTableDataOri, "risk_field_id", scopeRow.id);
      this.$set(this.commonFieldTableDataOri, "title", scopeRow.field_name);
      this.$set(
        this.commonFieldTableDataOri,
        "target_type",
        scopeRow.target_type
      );
      this.getCommonFieldOptions();
      this.showCommonFieldDialog = true;
    },

    async getCommonFieldOptions() {
      let res = await api.areaRiskFieldList({
        area_id: this.area_id,
        risk_id: this.commonFieldTableDataOri.risk_id,
        risk_field_id: this.commonFieldTableDataOri.risk_field_id
      });

      this.$set(this.commonFieldTableDataOri, "data", res.list);
      this.commonFieldTableData = this.$_.cloneDeep(res.list);
    },

    // 添加配置项
    doAddCommonFieldRow() {
      this.batchOperate = true
      let rowItemObj = {
        id: "",
        area_id: this.area_id,
        risk_id: this.commonFieldTableDataOri.risk_id,
        risk_field_id: this.commonFieldTableDataOri.risk_field_id,
        risk_field_value: "",
        risk_field_score: ""
      };
      this.commonFieldTableData.push(rowItemObj);
    },

    // 批量添加
    doAddCommonFieldRow2() {
      let datas = this.batchVal.split(/[(\r\n)\r\n]+/)
      // console.log(datas[0].split(","))
      datas.forEach(item => {
        this.commonFieldTableData.push(
          {
            id: "",
            area_id: this.area_id,
            risk_id: this.commonFieldTableDataOri.risk_id,
            risk_field_id: this.commonFieldTableDataOri.risk_field_id,
            risk_field_value: item.split(",")[0],
            risk_field_score: item.split(",")[1]
          }
        );
      })
      this.batchOperate = true
    },

    async deleteCommonFieldItem(scope) {
      let id = scope.row.id;
      if (
        id === "" &&
        scope.row.risk_field_value === "" &&
        scope.row.risk_field_value === ""
      ) {
        this.commonFieldTableData.splice(scope.$index, 1);
        return false;
      }

      await this.$confirm("确定删除该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });

      if (id) {
        await api.deleteAreaRiskField({
          id
        });

        this.getCommonFieldOptions();
        TipUtil.message("删除记录成功", "success");
      } else {
        this.commonFieldTableData.splice(scope.$index, 1);
      }
    },

    saveCommonFieldData() {
      // 判断是否都已填写
      let isAllFilled = this.commonFieldTableData.some(
        item => item.risk_field_value === "" || item.risk_field_score === ""
      );
      if (isAllFilled) {
        TipUtil.message("表单还有未填项", "error");
        return false;
      }

      this.commonFieldTableData.forEach(async (item, index) => {
        if (item.id) {
          // 如果有改变才调编辑接口
          let originData = this.commonFieldTableDataOri.data;
          let findIndex = originData.findIndex(fItem => fItem.id == item.id);

          console.log(findIndex);
          if (findIndex > -1) {
            if (
              item.risk_field_value !==
                originData[findIndex].risk_field_value ||
              item.risk_field_score !== originData[findIndex].risk_field_score
            ) {
              console.log("is equipppppp");
              await api.editAreaRiskField(item);
            }
          } else {
            console.log("is not equipppppp");
            await api.editAreaRiskField(item);
          }
        } else {
          await api.addAreaRiskField(item);
        }

        if (index == this.commonFieldTableData.length - 1) {
          TipUtil.message("模块配置内容保存成功", "success");
          this.showCommonFieldDialog = false;
        }
      });
    },

    async openPeopleNumFieldDialog(scopeRow) {
      this.peopleNumFieldTableData = this.$_.cloneDeep(
        this.peopleNumFieldTableDataOri
      );
      this.$set(this.peopleNumFieldTableData, "risk_id", scopeRow.risk_id);
      this.$set(this.peopleNumFieldTableData, "risk_field_id", scopeRow.id);
      this.$set(this.peopleNumFieldTableData, "title", scopeRow.field_name);
      this.$set(
        this.peopleNumFieldTableData,
        "target_type",
        scopeRow.target_type
      );
      this.getPeopleNumFieldOptions();
      this.showPeopleNumFieldDialog = true;
    },

    async getPeopleNumFieldOptions() {
      let res = await api.areaRiskFieldList({
        area_id: this.area_id,
        risk_id: this.peopleNumFieldTableData.risk_id,
        risk_field_id: this.peopleNumFieldTableData.risk_field_id
      });

      let resValueData = [];
      let columnScoreArr = [];
      for (let i = 0; i < 5; i++) {
        columnScoreArr.push({
          score: ""
        });
      }

      res.list.forEach(item => {
        this.peopleNumFieldTableData.id = item.id
        let parseObj = JSON.parse(item.risk_field_value)

        // 回填分数
        let parseScoreArr = parseObj.score.split(',')
        parseScoreArr.forEach((scoreItem, scoreIndex) => {
          columnScoreArr[scoreIndex].score = scoreItem
        })

        let parseValueArr = parseObj.value

        parseValueArr.forEach(valueItem => {
          let tempValueObj = {};
          for (let i = 1; i <= 5; i++) {
            tempValueObj["value" + i] = "";
          }
          let invovledKey = ''
          if (Object.keys(valueItem)[0].indexOf('death_and_injured') > -1) {
            invovledKey = 'death_and_injured'
          } else {
            let fullKeyArr = Object.keys(valueItem)[0].split('_')
            invovledKey = fullKeyArr[fullKeyArr.length -1]
          }

          tempValueObj.invovledKey = invovledKey
          let valueSplitArr = Object.values(valueItem)[0].split(',')
          valueSplitArr.forEach((vSplitItem, vSplitIndex) => {
            let tempVSplitItem = vSplitItem ? vSplitItem : ''
            let subSplitArr = tempVSplitItem.split('#')
            let subVSplitStr = tempVSplitItem.replace(/#/g, ',')
            if (subSplitArr.length >= 2) {
              subVSplitStr = '[' + subVSplitStr + ']'
            }
            tempValueObj['value' + (vSplitIndex + 1)] = subVSplitStr
          })

          resValueData.push(tempValueObj)
        })
      })
      this.$set(this.peopleNumFieldTableData, "columnScores", columnScoreArr);
      this.$set(this.peopleNumFieldTableData, "data", resValueData);
    },

    // 添加配置项
    doAddPeopleNumFieldRow() {
      let valueObj = {};
      for (let i = 1; i <= 5; i++) {
        valueObj["value" + i] = "";
      }

      let rowItemObj = {
        id: "",
        area_id: this.area_id,
        risk_id: this.peopleNumFieldTableData.risk_id,
        risk_field_id: this.peopleNumFieldTableData.risk_field_id,
        risk_field_value: "",
        invovledKey: "",
        ...valueObj
      };

      this.peopleNumFieldTableData.data.push(rowItemObj);
    },

    async deletePeopleNumFieldItem(scope) {
      this.peopleNumFieldTableData.data.splice(scope.$index, 1);
    },

    async savePeopleNumFieldData() {
      // 判断是否都已填写
      let isAllFilled = this.peopleNumFieldTableData.data.some(
        item => item.invovledKey == ""
      );
      if (isAllFilled) {
        TipUtil.message("表单有涉案类型未选", "error");
        return false;
      }
      let submitObj = this.processPeopleNumSubmitData();
      console.log(submitObj);
      if (this.peopleNumFieldTableData.id) {
        await api.editAreaRiskField(submitObj);
      } else {
        await api.addAreaRiskField(submitObj);
      }
      TipUtil.message("模块配置内容保存成功", "success");
      this.showPeopleNumFieldDialog = false;
    },

    processPeopleNumSubmitData() {
      let pnFormData = this.peopleNumFieldTableData;
      let retObj = this.$_.pick(pnFormData, [
        "id",
        "risk_id",
        "risk_field_id",
        "risk_field_value"
      ]);
      retObj.area_id = this.area_id;
      let scoreArr = pnFormData.columnScores.map(item => item.score);
      let combineObj = {
        score: scoreArr.join(",")
      };

      let valueArr = [];
      pnFormData.data.forEach(item => {
        let forItemValueArr = [];
        for (let i = 1; i <= 5; i++) {
          let inputValue =
            item["value" + i] === "" || item["value" + i] === undefined
              ? ","
              : item["value" + i];
          inputValue = inputValue
            .replace(/\[/g, "")
            .replace(/\]/g, "")
            .trim();
          let splitvalueArr = inputValue.split(",");
          console.log(splitvalueArr);

          let valueStr = "";
          if (splitvalueArr.length == 0) {
            valueStr = "#";
          } else if (splitvalueArr.length == 1) {
            valueStr = splitvalueArr[0] + "#";
          } else {
            valueStr = splitvalueArr[0] + "#" + splitvalueArr[1];
          }

          forItemValueArr.push(valueStr);
        }
        let invovledPrefix =
          pnFormData.target_type == 1 ? "commonPrefix" : "shehuaPrefix";

        let valueKeyStr =
          this.$enums.InvolvedType[invovledPrefix] + item.invovledKey;
        console.log(valueKeyStr);
        valueArr.push({
          [valueKeyStr]: forItemValueArr.join(",")
        });
      });

      combineObj.value = valueArr;
      retObj.risk_field_value = JSON.stringify(combineObj);
      return retObj;
    },
    // 1.4 重大时间节点修改
    doEdit(row) {
      this.isEdit = true
      console.log(row.begin_time.toString().length)
      
      if(row.year_repeat) {
        row.year_repeat = 1
      }else {
        row.year_repeat = 0
      }
      this.showFormDialog = true
      if(row.begin_time) {
        if(row.begin_time.toString().length > 10) {
          // this.$set(row,"begin_time",row.begin_time/1000)
          // this.$set(row,"end_time",row.end_time/1000)
        }else {
          this.$set(row,"begin_time",row.begin_time*1000)
          this.$set(row,"end_time",row.end_time*1000)
        }
      }
      this.formData = row
      console.log(this.formData)
    },

    async submitEditForm() {
      if(this.formData.begin_time.toString().length > 10) {
        this.$set(this.formData,"begin_time",this.formData.begin_time/1000)
        this.$set(this.formData,"end_time",this.formData.end_time/1000)
      }
      let res = await api.editFestival(this.formData);
      this.showFormDialog = false
      TipUtil.message("修改成功", "success");
      this.$refs.dataTable.refresh();
    }

  },

  created() {
    let area_id = this.$route.query.area_id;
    if (area_id) {
      this.area_id = parseInt(area_id);
      this.isConfigEdit = true;
    }

    this.initCommonData();
  },
  mounted() {},
  beforeDestroy() {},
  filters: {
    configTitleText(curId) {
      let retStr = "";
      if (curId == 2) {
        retStr = "节日";
      } else if (curId == 3) {
        retStr = "影响性";
      } else if (curId == 5) {
        retStr = "特殊加权";
      }

      return `${retStr}配置值`;
    }
  }
};
</script>

<style lang="less">
.config-model-table-title {
  margin-top: 15px;
  padding: 15px 20px;
  background: #f6f6f6;
  text-align: center;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  font-size: 14px;
  font-weight: bold;
  &.style-mt-0 {
    margin-top: 0;
  }
}
.config-model-main-tips {
  font-size: 12px;
  color: #999;
  padding-top: 5px;
}
</style>
